/**
 * Utility class for getting the number of milliseconds in a given duration.
 */
export class Duration {
  static ofWeeks(weeks: number): number {
    return weeks * 7 * 24 * 60 * 60 * 1000;
  }

  static ofDays(days: number): number {
    return days * 24 * 60 * 60 * 1000;
  }

  static ofHours(hours: number): number {
    return hours * 60 * 60 * 1000;
  }

  static ofMinutes(minutes: number): number {
    return minutes * 60 * 1000;
  }

  static ofSeconds(seconds: number): number {
    return seconds * 1000;
  }
}
